/*
 * VLS product landings: capsule gallery.
 * Thumbnails switch the main image and update the "1 / 4" counter.
 * Everything else on the landings (purchase options, FAQ) works with plain
 * HTML (radio inputs, <details>), so it keeps working without JavaScript.
 */
if (!customElements.get('vls-gallery')) {
  class VlsGallery extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.addEventListener('click', (event) => this.onClick(event), { signal });
      this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    get slides() {
      return [...this.querySelectorAll('.vls-gallery__slide')];
    }

    get thumbs() {
      return [...this.querySelectorAll('.vls-gallery__thumb')];
    }

    /** @param {MouseEvent} event */
    onClick(event) {
      const thumb = event.target instanceof Element ? event.target.closest('.vls-gallery__thumb') : null;
      if (!thumb || !this.contains(thumb)) return;
      this.show(Number(thumb.dataset.index) || 0);
    }

    /** Left/right arrows move between thumbnails, like a tab list. */
    onKeydown(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      const thumbs = this.thumbs;
      const current = thumbs.indexOf(document.activeElement);
      if (current === -1) return;
      event.preventDefault();
      const step = event.key === 'ArrowRight' ? 1 : -1;
      const next = (current + step + thumbs.length) % thumbs.length;
      this.show(next);
      thumbs[next].focus();
    }

    /** @param {number} index */
    show(index) {
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== index;
      });
      this.thumbs.forEach((thumb, i) => {
        thumb.setAttribute('aria-pressed', String(i === index));
      });
      const current = this.querySelector('[data-vls-current]');
      if (current) current.textContent = String(index + 1);
    }
  }

  customElements.define('vls-gallery', VlsGallery);
}
